import React, { useEffect, useState, useContext } from 'react';
import './homes.css'
import {
    Radio,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Box,
    Container,
    Typography,
    Button,
    MenuItem,
    Menu
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import CityMenu from '../dropdowns/dropdownCity';
import { NavigatorContext } from '../../contexts/NavigatorContext';


const months = ["Jan'", "Feb'", "Mar'", "April", "May", "June", "July", "Aug'", "Sept'", "Oct'", "Nov'", "Dec'"];
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const saerchBtnStyle = {
  position: 'sticky',
  left: '40%',
  top:'65%',
  fontSize: '30px',
  borderRadius: '30px',
  width: '300px',
  marginTop:'100px'
}
const numberArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export default function HomeStay() {

    const [value, setValue] = useState("group1");
    const [date,setDate] = useState();
    const [depDate, setDepDate] = useState();
    const [userDate, setUserDate] = useState(new Date());
    const [outDay, setOutDay] = useState(new Date());
    const {user} = useUserAuth();
    const navigate = useNavigate();
    const [cityClicked, setCityClicked] = useState(true);
    const {setParam} = useContext(NavigatorContext);
    useEffect(()=>{
      setParam('home');
    }, [])
    useEffect(()=>{
      setUserDate(new Date(date));
    }, [date]);
    useEffect(()=>{
      setOutDay(new Date(depDate));
    }, [depDate])
    const handleChange = (e)=> {
        setValue(e.target.value);
    }
    function LocationCard(props){
      const handleCityShow = ()=>{
        setCityClicked(true);
      }
        return(
            <div className='location' onMouseOver={handleCityShow}>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}}>{props.firstLine}</Typography>
                <Typography variant='h1' fontSize='40px' sx={{fontFamily:'Poppins'}}>{props.selectCity}</Typography>
                <Typography variant='body2' fontWeight='bold' sx={{fontFamily:'Poppins'}}>{props.country}</Typography>
            </div> 
        )
    }
    const [room, setRoom] = useState(1);
    const [adult, setadult] = useState(2);
    function TravellerCount(){
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      const handleSelectTag1 = (e)=>{
        setRoom(e.target.value);
        setAnchorEl(null);
      }
      const handleSelectTag2= (e)=> {
        setadult(e.target.value);
        setAnchorEl(null);
      }
      return (
        <div className='location'>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{textTransform:'none', textAlign:'left'}}
          >
            Add number of guests
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem>
              <div className='traveller-apart'>
                <h3>Rooms</h3>
                <div>
                  <select onChange={handleSelectTag1} value={room}>
                    {numberArray.map(el=>{
                      return <option key={el} value={el}>{el}</option>
                    })}
                  </select>
                </div>
              </div>
            </MenuItem>
            <MenuItem>
            <div className='traveller-apart'>
                <h3>Adults</h3>
                <div>
                  <select onChange={handleSelectTag2} value={adult}>
                    {numberArray.map(el=>{
                      return <option key={el}>{el}</option>
                    })}
                  </select>
                </div>
              </div>
            </MenuItem>
            <MenuItem>
            <div className='traveller-apart'>
                <h3>Children</h3>
                <div>
                  <select>
                    {numberArray.map((el, idx)=>{
                      return <option key={el}>{idx}</option>
                    })}
                  </select>
                </div>
              </div>
            </MenuItem>
          </Menu>
          <div style={{display:'flex'}}><h1 style={{fontSize:'30px'}}>{room}</h1><h4>Room</h4><h1 style={{fontSize:'30px'}}>{adult}</h1><h4>Adults</h4></div>
        </div>
      );
    }
    function UtilityCard(props){
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);
        const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };
        useEffect(()=>{
          if(date && date.length>=10){
            setAnchorEl(null);
          }
      }, [date]);
      useEffect(()=>{
        if(depDate && depDate.length>=10){
          setAnchorEl(null);
        }
      }, [depDate]);
        const handleDateChange = (e)=>{
            if(props.enter){
                setDate(e.target.value);    
            }else if(!props.enter){
                setDepDate(e.target.value);
            }
        }
        
        return (
        <div style={{textAlign:'center'}}>
        <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none',paddingBottom:'-10px'}}
      >
        {props.options}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem><input type='date' onChange={handleDateChange}/></MenuItem>
      </Menu>
    </div>
    )
    }
    function DateCard(props){
        return (
            <div className='dateCard'>
            <UtilityCard options={props.options} />
            <br />
            {props.enter && <div>
            {date ? <div>
            <Box display='flex'>
            <Typography variant='div' fontSize='30px' fontWeight='bolder' lineHeight='0.5'>{userDate.getDate()}</Typography>
            <Typography variant='h3' fontSize='23px'>{months[userDate.getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px'>{userDate.getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[userDate.getDay()]}</Typography>
            </div> : 
            <div>
            <Box display='flex'>
            <Typography variant='div' fontSize='30px' fontWeight='bolder' lineHeight='0.5'>{new Date().getDate()}</Typography>
            <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
            <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
            </Box>
            <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
            </div>
            }
        </div>}
        {!props.enter && <div>
        {depDate ? <div>
          <Box display='flex'>
          <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{outDay.getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[outDay.getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{outDay.getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[outDay.getDay()]}</Typography>
        </div> : 
        <div>
          <Box display='flex'>
          <Typography variant='h1' fontSize='30px' lineHeight='0.5'>{new Date().getDate()}</Typography>
          <Typography variant='h3' fontSize='23px'>{months[new Date().getMonth()]}</Typography>
          <Typography variant='h3' fontSize='23px'>{new Date().getFullYear()}</Typography>
          </Box>
          <Typography variant='body2' fontWeight='bold' textAlign='left'>{days[new Date().getDay()]}</Typography>
        </div>
        }
        
        </div>}
        </div>
        )

    }
    function LastPricingCard(){
      const [pricing, setPricing] = useState("0-1500");
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      const handlePrice = (e)=>{
        setPricing(e.target.textContent);
        setAnchorEl(null);
      }
      return (
        <div className='pricing'>
          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            endIcon={<KeyboardArrowDownIcon />}
            sx={{textTransform:'none'}}
          >
            Price per Night
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={handlePrice}>3000-5000</MenuItem>
            <MenuItem onClick={handlePrice}>5000-8000</MenuItem>
            <MenuItem onClick={handlePrice}>8000-10000</MenuItem>
            <MenuItem onClick={handlePrice}>10000-15000</MenuItem>
            <MenuItem onClick={handlePrice}>15000-20000</MenuItem>
          </Menu>
          <Typography variant='body2' fontWeight='bold'>Price per night</Typography>
          <Typography variant='div' component='h3'>{pricing}</Typography>
        </div>
      );
    }
    const handleTickets = ()=> {
      if(user){
        navigate('/tickets/home');
      }else{
        navigate('/login');
      }
    }
    const [city, setCity] = useState("Goa");
    const handleCity = ()=> {
      setCityClicked(true);
    }
  return (
    <div>
        <div className='home-card' onClick={handleCity}>
        <Container>
           <div className='heading-home'><p>Book your ideal Homestay - Villas, Apartments & more.</p></div>
        </Container>
        <div className='slider'>
           <Box display='flex'>
            <LocationCard firstLine={"City, Property Name Or Location"} selectCity={city} country={"India"} />
            <DateCard options={'Add Check-In Date'} enter={false} />
            <DateCard options={'Add Check-Out Date'} enter={true} />
            <TravellerCount />
            <LastPricingCard />
           </Box>
        </div>
        <Button variant='contained' sx={saerchBtnStyle} onClick={handleTickets}>SEARCH</Button>
        </div>
        {cityClicked && <div className='positionMenu'> <CityMenu setterFunc={setCity} removeMenu={setCityClicked}/></div>}
    </div>
  )
}
